// extracted by mini-css-extract-plugin
module.exports = {"root":"List-module__root___2126M","news":"List-module__news___3Ruax"};